import { Trans } from "react-i18next";
import { Link } from "components/buttons/Link";
import { useMaintenancePlan } from "hooks/useMaintenancePlan";
import styles from "./index.module.scss";

export type MaintenanceNoticePage =
    "home" | "livestreams" | "cloud-assets" | "video-library";

interface MaintenanceNoticeProps {
    page: MaintenanceNoticePage;
}

export const MaintenanceNotice: React.FC<MaintenanceNoticeProps> = ({
    page
}) => {
    const plan = useMaintenancePlan();

    if (!plan) return null;

    const restartLink = {
        link1: <Link to="/subscription#openModal" />
    };

    if (page === "home") {
        return (
            <div className={styles["notice"]} role="status">
                <p className={styles["title"]}>
                    <Trans i18nKey={`maintenance-plan:home-title-${plan}`} />
                </p>
                <p>
                    <Trans
                        i18nKey={`maintenance-plan:home-body-${plan}`}
                        components={restartLink}
                    />
                </p>
            </div>
        );
    }

    return (
        <div className={styles["notice"]} role="status">
            <p>
                <Trans
                    i18nKey={`maintenance-plan:${page}-${plan}`}
                    components={restartLink}
                />
            </p>
        </div>
    );
};
